import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "Entity Renderer")
], -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("complete")

import ButtonComponent from '@/components/ButtonComponent.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'DebugPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createVNode(ButtonComponent, {
      onClick: _cache[0] || (_cache[0] = () => {})
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}
}

})